import React from "react";

function Toast({ setToastShow, textToast, time, color="bg-red-400" }) {
  setTimeout(() => setToastShow(false), time);
  return (
    <div className="absolute top-10 left-0 w-full justify-center items-center flex animate-bounce">
      <div className={`max-w-[500px] w-[40%] ${color} text-center py-2 rounded-xl text-white`}>
        {textToast}
      </div>
    </div>
  );
}

export default Toast;
